var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import marker1 from '../../assets/marker1.png';
import marker2 from '../../assets/marker2.png';
import marker3 from '../../assets/marker3.png';
import clsx from 'clsx';
import styles from './marker.module.css';
var Marker = function (_a) {
    var children = _a.children, variant = _a.variant;
    var marker = variant === 'marker1'
        ? marker1
        : variant === 'marker2'
            ? marker2
            : marker3;
    return (_jsx("span", __assign({ className: clsx(styles.marker), style: {
            backgroundImage: "url(".concat(marker, ")"),
        } }, { children: children })));
};
export default Marker;
